import React from 'react';

interface BigBoothProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  title?: string;
  twoCols?: boolean;
}

const BigBoothTwoColsSection = ({ children, title, twoCols = true, className, ...props }: BigBoothProps) => {
  return (
    <div {...props} className={`mt-12 flex flex-col w-full ${className}`}>
      {title && <p className="mb-4 text-xl font-bold text-gray-700">{title}</p>}
      <div className={`grid ${twoCols ? 'lg:grid-cols-2' : 'lg:grid-cols-1'} gap-4 self-center w-full`}>{children}</div>
    </div>
  );
};

export default BigBoothTwoColsSection;
